import { Component, OnInit, Input } from '@angular/core';
import { MailOnglet, MailService } from './mail.service';

@Component({
  selector: 'queoval-stage-mail',
  templateUrl: './mail.component.html',
  styleUrls: ['./mail.component.css'],
  providers: [MailService]
})
  /* Composant parent qui permet de créer un mail en 3 étapes*/
export class MailComponent implements OnInit {
  // #region CONSTRUCTEUR
  constructor(
    public mailService: MailService,
  ) { }
  // #endregion

  // #region VARIABLES GLOBALES
  // Condition d'affichage des "pulse" sur les différentes étapes
  public pulseButton: boolean = true;
  /* permet de savoir si une étape a était sélectionné*/
  public stepIsSelected: boolean = false;
  /* texte affiché qui change à chaque étape*/
  public textFilAriane: string = "Envoi de mail";
  // Input pour savoir si on affiche ou non "l'éclairage" sur les bouton en mode tuto (1ère page)
  @Input()
  set isModeTuto(value: boolean) {
    this.pulseButton = value;
  }
  // #endregion

  // #region CYCLE DE VIE
  ngOnInit(): void {
    this.mailService.VerifyIfListDestIsEmpty();
  }
  // #endregion

  // #region FONCTIONS PUBLIQUES
  // #endregion

  // #region FONCTIONS PRIVES
  /**
   * Fonction qui va permettre d'afficher l'étape sélectionnée dans l'interface
   * @param elt élément qui représente une étape pour la création de mail
   */
  GetStep(elt: { Title: string, Type: MailOnglet, Icon: string, Name: string, Active: boolean, Visible: boolean, Locked: boolean }): void {
    this.stepIsSelected = true;
    this.mailService.tabs.forEach(step => {
      if (step.Type === elt.Type) {
        step.Active = true;
        this.textFilAriane = elt.Name;
      } else {
        step.Active = false;
      }
    })
  }
  // #endregion
  
}


